import {OwayoJSKonfiViewer} from "./owayoJSViewerWithSelObs";
import {createGUID} from "../global/globalUtils";

export class ModelRotatorSingleton {

    public static guidRotrating = null as string|null;

    public static rotateModelToTargetAngleDegree(owayoJSViewer:OwayoJSKonfiViewer, targetAngleDegree, guidRotating:string|null = null) {

        if((guidRotating === null && ModelRotatorSingleton.guidRotrating !== null) || guidRotating !== ModelRotatorSingleton.guidRotrating) {
            return;
        }
        if(Math.abs(targetAngleDegree) >= 360) {
            targetAngleDegree = targetAngleDegree % 360;
        }
        // const counterClockWise = targetAngleDegree < 0;
        // if(targetAngleDegree < 0) {
        //     targetAngleDegree = 360 + targetAngleDegree;
        // }
        if(guidRotating === null) {
            guidRotating = createGUID();
            ModelRotatorSingleton.guidRotrating = guidRotating;
        }
        // noinspection JSSuspiciousNameCombination
        const currentRotation = owayoJSViewer.modelObjects[0].rotation.y;
        const step = 5 *  Math.PI / 180;
        if (Math.abs(currentRotation - (targetAngleDegree * Math.PI / 180)) < step) {
            ModelRotatorSingleton.guidRotrating = null;
            return;
        }
        if(currentRotation > targetAngleDegree * Math.PI / 180) {
            owayoJSViewer.updateModelRotation(0, currentRotation - step);
            setTimeout(function() {
                owayoJSViewer.rotateToTargetAngleDegree(targetAngleDegree, guidRotating);
                },
                10
            );
            return;
        }
        owayoJSViewer.updateModelRotation(0, currentRotation + step);
        setTimeout(function() {owayoJSViewer.rotateToTargetAngleDegree(targetAngleDegree, guidRotating);}, 10);
    }
}
